module.exports = __webpack_public_path__ + "static/media/blackjack-2.5b7e38ab.JPG";